import UrlLinkBuilder from '@alme/ui-web/modules/message-renderer-display-links/src/builders/urlLinkBuilder';

import { DisplayLink } from "@alme/types/response/DisplayLink";
import { sendRequest } from '../../../node_modules/@alme/ui-web/modules/lib-alme-request/src/lib-alme-request';
import { Input } from '@alme/ui-web/types/input';
import { EntryOriginTypesV5 } from '@alme/api-ts/Alme/EntryOriginTypes';
import { setMinimize } from "../../../node_modules/@alme/ui-web/modules/window-minimize/src/actions/actions";
import { getAlightLinkDetails } from '../../lib-alight-library/lib-alight-library';
import { AlightCustomSettingsType } from '../../../settings/alight-custom-settings';
import { h, VNode } from "virtual-dom";
import {
    isLiveChat,
} from '@alme/ui-web/modules/lib-livechat/lib/lib-livechat';
import { Dictionary } from '@alme/ui-web/types/rendering';
import { allowNav, isDNNLocation } from '@alme/ui-web/util/dnn';
export default class CustomUrlLinkBuilder extends UrlLinkBuilder {
    //Override onclick
    buildUrlLink(link: DisplayLink): VNode[] {
        const shouldDisable = this._store?.getState().Window.DisplayLinksUrl.shouldDisable;
        let connectionStatus = isLiveChat(this._store, this._settings);
        const isDownloadLink = link.Metadata.Download ? true : false;
        let urlAddress: any = link.Metadata.UrlAddress;

        let parameters: Dictionary = shouldDisable
            ? {
                tabindex: -1,
                href: '/',
                onclick: (): boolean => false,

            }
            : (!connectionStatus) ? isDownloadLink ?
                {
                    href: link.Metadata.UrlAddress,
                    download: link.Metadata.Download,
                    onclick: (): boolean => {
                        this.urlOnClickReporting(link);
                        return true;
                    },
                }
                : {
                    tabindex: 0,
                    href: isDNNLocation(window.location, this._settings) ? '' : (link.Metadata.UrlRequiresEncoding === "true") ? encodeURI(urlAddress) : urlAddress,
                    target: this.isPopup(link) ? "_blank" : "_self",
                    onclick: (): boolean => {
                        this.urlOnClick(link);
                        return false;
                    },
                } : {
                tabindex: -1,
                href: '/',
                onclick: (): boolean => false,
            };

        parameters = this._linkMutators.reduce((props, mutate) => mutate(props), parameters)

        const stepOutNode = this._stepOutIcon?.renderIcon(link.Metadata.UrlAddress as string);
        
        
        const alightSettings = this._settings as AlightCustomSettingsType;
        const linkObj = getAlightLinkDetails(urlAddress);
        if (!link?.Metadata?.onClickFunctionString) {
            if (alightSettings.configurationType.includes(linkObj.type) && window?.ivaRouting) {
                parameters['href'] = 'javascript:void(0)';
            }
        }
        let children = [h('a', parameters, stepOutNode ? [link.DisplayText, stepOutNode] : link.DisplayText)];

        const properties = {
            className: shouldDisable ? this._settings.classNames.displayLinkDisabled : (!connectionStatus) ? this._settings.classNames.urlDisplayLink : this._settings.classNames.displayLinkDisabled,
        };
        
        if (link?.DisplayText !== "") {
            return [h('div', properties, children)];
        }
        else {
            return [];
        }
    }
    urlOnClick(link: DisplayLink): void {
        this.handleLinkReporting(link.Metadata.UrlAddress as string);
        this.minimizeAgentInMobileView();

        if (Object.prototype.hasOwnProperty.call(window, "genWarningPopup")) { //  checking to make sure genWarningPopup exists on this UPOINT page
            if (window.genWarningPopup == 'Y') {
                //  call UPOINT provided function and pass it the link
                if (window.genericWarningPopup({ href: link.Metadata.UrlAddress as string })) {
                    this.doNavLogic(link, this.isPopup(link));
                }
            }
            else {
                this.doNavLogic(link, this.isPopup(link));
            }
        }
        else {
            this.doNavLogic(link, this.isPopup(link));
        }
    }

    isPopup(link: DisplayLink): boolean {
        return link.Metadata.NavigationType === "Popup";
    }

    doNavLogic(link: DisplayLink, isPopup: boolean): void {
        if (link?.Metadata?.onClickFunctionString) {
            const customOnClick = new Function(link.Metadata.onClickFunctionString as string);
            customOnClick();
        }

        const url = link.Metadata.UrlAddress as string;
        const input: Input =
        {
            eventName: 'UrlClicked',
            eventValue: url,
            messageType: this._settings.messageConstants.reportingEventRequest,
        };

        const navPromise = sendRequest(input);

        const alightSettings = this._settings as AlightCustomSettingsType;

        const linkObj = getAlightLinkDetails(url);

        if (alightSettings.configurationType.includes(linkObj.type) && window?.ivaRouting) {
            window?.ivaRouting(linkObj.type, linkObj.source, linkObj.name, linkObj.gnrc1, linkObj.gnrc2);
        }
        else {
            navPromise.then(() => {
                if (!isPopup) {
                    this.setWindowLocationHref(url);
                }
            });

            if (isPopup) {
                const newWin = window.open(url, '_blank');
                newWin?.focus();
            }
        }
    }

    isClick2CallLink(linkUrl: string): boolean {
        const lowerCaseLink = linkUrl.toLowerCase();
        return lowerCaseLink.includes("linkid=click_to_call_secondary");
    }

    isScheduleAnAppointment(linkUrl: string): boolean {
        const lowerCaseLink = linkUrl.toLowerCase();
        return lowerCaseLink.includes("linkid=appointment_scheduler1") ||
            lowerCaseLink.includes("linkid=appointment_scheduler") ||
            lowerCaseLink.includes("linkid=mobile_appt_link");
    }

    isContactUs(linkUrl: string): boolean {
        const lowerCaseLink = linkUrl.toLowerCase();
        return lowerCaseLink.includes("linkid=iva_contact_us_link");
    }

    isSubmitHelpRequest(linkUrl: string): boolean {
        const lowerCaseLink = linkUrl.toLowerCase();
        return lowerCaseLink.includes("linkid=hrx_casemanagement_link");
    }

    getReportingEventType(linkUrl: string): string {
        if (this.isClick2CallLink(linkUrl))
            return "Click2Call";

        if (this.isScheduleAnAppointment(linkUrl)) {
            return "ScheduleAnAppointment";
        }

        if (this.isContactUs(linkUrl)) {
            return "ContactUs";
        }

        if (this.isSubmitHelpRequest(linkUrl)) {
            return "SubmitHelpRequest"
        }

        return "NotReportingLink";
    }

    handleLinkReporting(linkUrl: string): void {

        const typeOfLink = this.getReportingEventType(linkUrl);

        if (typeOfLink !== "NotReportingLink") {

            const eventName = "ReportingEvents.EscalationUrlType";
            const eventValue = typeOfLink;
            const eventOrigin = this._settings.originConstants.click;
            const input: Input = {
                messageType: this._settings.messageConstants.reportingEventRequest,
                eventName: eventName,
                eventValue: eventValue,
                origin: eventOrigin as EntryOriginTypesV5,
            };
            sendRequest(input);
        }
    }

    minimizeAgentInMobileView(): void {
        const windowWidth = window.innerWidth ?? document.documentElement.clientWidth ?? document.body.clientWidth;

        if (windowWidth <= this._settings?.Mobile?.breakpoint ?? -1) {
            this._store?.dispatch(setMinimize(true, this._settings.stateLocations.Window.IsMinimized));
        }
    }

}


// WEBPACK FOOTER //
// ./modules/custom-message-renderer-display-links/builders/customUrlLinkBuilder.ts